import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { User } from '@classes/user';
import { UserDetail } from '@classes/user-detail';
import { UserGridViewItem } from '@classes/user-grid-view-item';
import { MessageBox } from '@components/message-box/message-box.component';
import { Role } from '@enums/role.enum';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from 'app/core/services/account.service';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';
import { UiService } from 'app/core/services/ui.service';
import { UserService } from 'app/core/services/user.service';
import { UserDetailComponent } from '../user-detail/user-detail.component';
// import { environment } from '@environments/environment';

@Component({
  selector: 'app-users-grid',
  templateUrl: './users-grid.component.html',
  styleUrls: ['./users-grid.component.scss']
})
export class UsersGridComponent implements OnInit {
  environment = this.envConfigurationService.environment;

  environmentName = this.environment.application;
  Role = Role;
  dataSource = new MatTableDataSource<UserGridViewItem>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'login',
    'firstName',
    'lastName',
    'email',
    'company',
    'role',
    'creationDate',
    'action'
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    public userService: UserService,
    public uiService: UiService,
    private accountService: AccountService,
    public translateService: TranslateService,
    public envConfigurationService: EnvConfigurationService
  ) { }

  ngOnInit() {
    this.dataSource.sortingDataAccessor = (element: any, property: any) => {
      switch (property) {
        case 'role': return (element.roleName);
        case 'company': return (element.company?.name);
        default: return element[property];
      }
    };
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    this.getUsers();
  }

  getUsers() {
    this.uiService.addRouteLoading();
    this.userService.getUsers().subscribe((data) => {
      this.dataSource.data = data.map(user => new UserGridViewItem({
        id: user.id,
        login: user.login,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        company: user.company,
        creationDate: user.creationDate,
        creationUser: user.creationUser,
        role: user.role
      }));
      this.uiService.removeRouteLoading();
    }, (error) => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  selectItemClick(user: UserGridViewItem) {
    this.selectedRowID = user.id || '';
  }
  onEditUser(user: UserGridViewItem) {
    const user_ = new User({
      id: user?.id,
      login: user?.login,
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
      company: user?.company,
      role: user?.role,
      role_: user?.role_,
    });
    const data = new UserDetail({
      user: user_,
      isEditMode: true,
    });

    const dialogRef = this.dialog.open(UserDetailComponent, {
      data,
      hasBackdrop: true
    });

    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.getUsers();
        this.uiService.displayMessageToast('user.success-edit');
      }
      if (user.id == this.accountService.currentUser.getValue()?.id) {
        this.accountService.getCurrentUser();
      }
    })
  }
  onDeleteUser(user: UserGridViewItem) {
    if (user && user.id) {

      const messageBoxParameter = new MessageBoxParameter();

      messageBoxParameter.message = this.translateService.instant('user.confirm-delete');
      messageBoxParameter.dialog = this.dialog;
      messageBoxParameter.title = 'Confirmation';
      messageBoxParameter.buttons = ['yes', 'no'];
      messageBoxParameter.width = "400px";

      MessageBox.show(messageBoxParameter).subscribe(mbResult => {
        if (mbResult && mbResult.value) {
          this.uiService.addRouteLoading();
          this.userService.deleteUser(user?.id || "").subscribe(data => {
            this.uiService.displayMessageToast('user.success-delete');
            this.uiService.removeRouteLoading();
            this.getUsers();
          }, error => {
            console.error(error);
            this.uiService.removeRouteLoading();
          });
        }
      });
    }
  }
}
